const AlertSubcriptionField = {
	announcements: "announcements",
	blogs: "blogs",
	statement_of_understanding: "statement_of_understanding",
	registration_help: "registration_help",
	dependent_creation: "dependent_creation",
	dependent_creation_request: "dependent_creation_request",
	dependent_creation_approval: "dependent_creation_approval",
	dependent_registration: "dependent_registration",
	employee_creation: "employee_creation",
	employee_registration: "employee_registration",
	employer_creation: "employer_creation",
	employer_registration: "employer_registration",
	admin_creation: "admin_creation",
	admin_registration: "admin_registration",
	super_admin_registration: "super_admin_registration",
	employee_profile_information_change: "employee_profile_information_change",
	employee_contact_information_change: "employee_contact_information_change",
	dependent_profile_information_change: "dependent_profile_information_change",
	dependent_contact_information_change: "dependent_contact_information_change",
	benefit_change: "benefit_change",
	reinstate_enrollment: "reinstate_enrollment",
	rehire_enrollment: "rehire_enrollment",
	termination: "termination",
	new_hire_enrollment: "new_hire_enrollment",
	grievance_logged: "grievance_logged",
	plan_creation: "plan_creation",
	open_enrollment: "open_enrollment",
	enrollment_submission: "enrollment_submission",
	enroller_action: "enroller_action",
	portal_accessibility: "portal_accessibility"
};

export const ALERT_SUBSCRIPTION_FIELD = AlertSubcriptionField;
